export const idvFraudScreenStatus = {
	FRAUD_SCREEN_STATUS_VERIFIED: 'FRAUD_SCREEN_STATUS_VERIFIED',
	FRAUD_SCREEN_STATUS_NOT_VERIFIED: 'FRAUD_SCREEN_STATUS_NOT_VERIFIED',
	FRAUD_SCREEN_STATUS_DENIED: 'FRAUD_SCREEN_STATUS_DENIED',
	FRAUD_SCREEN_STATUS_WAITING_ROOM: 'FRAUD_SCREEN_STATUS_WAITING_ROOM',
	ERROR: 'error',
};

export const idvVerificationAction = {
	VERIFICATION_ACTION_REVIEW_PII: 'VERIFICATION_ACTION_REVIEW_PII',
	VERIFICATION_ACTION_REVIEW_DOCUMENTS: 'VERIFICATION_ACTION_REVIEW_DOCUMENTS',
	VERIFICATION_ACTION_NONE: 'VERIFICATION_ACTION_NONE',
};

export const idvScreenNames = {
	CHECK_LOADER: 'CHECK_LOADER',
	CELEBRATION: 'CELEBRATION',
	HARD_FAIL: 'HARD_FAIL',
	ALLOY_OUTAGE: 'ALLOY_OUTAGE',
	DOC_UPLOAD: 'DOC_UPLOAD',
	MANUAL_REVIEW: 'MANUAL_REVIEW',
	IDV_FLOW: 'IDV_FLOW',
	GENERIC_ERROR: 'GENERIC_ERROR',
};

export const idvTimeouts = {
	POLLING_INTERVAL: 3_000, // 3 secs
	POLLING_TIMEOUT_LIMIT: 30_000, // 30 secs
	RETURN_DELAY: 5_000, // 5 secs
};

export const idvPxQuestionsAnswerTypes = {
	COMPLETE: 'COMPLETE',
	INCOMPLETE: 'INCOMPLETE',
};

export const IDV_PX_QUESTION_NAME = 'onboarding-identity-verification-status';
export const RETURN_TO_KEY = 'returnTo';
export const RETURN_TO_VALUE = 'idvFlow';
